<template>
    <div class="m-anchor">
        <h5 class="title"></h5>

        <div class="view">
            <div class="anchor-list" v-if="ready">
                <div class="anchor-item" v-for="(item,index) in list" :key="index">
                    <div class="avatar">
                        <img :src="item.logo" :alt="item.name">
                    </div>
                    <p class="anchor-name">{{ item.name }}</p>
                </div>
            </div>

            <loading v-else/>
        </div>
    </div>
</template>

<script>
export default {
    data (){
        return {
            list : [],
            ready : false,
        }
    },
    props :{
        'active' : {
            default : false,
        }
    },
    created (){
        // this.render_live();
        // this.render_news();
    },
    watch : {
        active (val){
            if(val && !this.ready){
                this.render();             
            }
        },
    },
    methods : {
        render(){
            this.$axios.get(this.$ajax_url_map.anchor)
            .then(
                res => {
                    this.list = res
                    this.ready = true
                },
                rej => {}
            )            
        },
    },  
}
</script>

<style scoped>
    .m-anchor{
        margin-top: 115px;
    }

    .title{
        width: 238px;
        height: 57px;
        margin-bottom: 55px;
        background-image: url(~@/assets/images/anchor/title.png);        
    }

    .m-anchor .view{
        position: relative;
        /* min-height: 524px; */
        min-height: 270px;
    }

    .anchor-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 70px;
    }

    .anchor-item{
        width: 190px;
        margin: 0 46px 30px;
    }    

    .avatar{
        position: relative;
        width: 171px;
        height: 171px;
        margin: 0 auto;
        background-image: url(~@/assets/images/anchor/bg-item.png);
        border-radius: 50%;
        overflow: hidden;
    }

    .avatar img{
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        max-width: 160px;
        transform: translate(-50%,-50%);
        
    }

    .anchor-name{
        margin-top: 28px;
        font-size: 22px;
        color: #fff;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/anchor.vue